import { render, staticRenderFns } from "./serviceFeeModalNew.vue?vue&type=template&id=0305f60d&scoped=true"
import script from "./serviceFeeModalNew.vue?vue&type=script&lang=js"
export * from "./serviceFeeModalNew.vue?vue&type=script&lang=js"
import style0 from "./serviceFeeModalNew.vue?vue&type=style&index=0&id=0305f60d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0305f60d",
  null
  
)

export default component.exports